import React from 'react';
import * as RadixToast from '@radix-ui/react-toast';
import styles from './toast-viewport.module.scss';

export const ToastViewport: React.FC = () => {
  return <RadixToast.Viewport className={styles.root} />;
};
